import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { TransportOrderIdView, ShipmentCommentsModel } from '../../../../models';
import {
  ShipmentTransportOrderCommentsInitialState,
  ShipmentTransportOrderCommentsLoad,
  ShipmentTransportOrderCommentsSave,
} from './shipment-transport-order-comments.actions';
import { ShipmentTransportOrderCommentsState } from './shipment-transport-order-comments.state';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderCommentsFacade implements LoadDataFacade, SetInitialStateFacade {
  comments$: Observable<ShipmentCommentsModel[]> = this.store.select(ShipmentTransportOrderCommentsState.getComments);
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderCommentsState.getLoaded);

  constructor(private store: Store) {}

  loadAll(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderCommentsLoad(identifier));
  }

  saveTransportOrderComment(identifier: TransportOrderIdView, comment: string): void {
    this.store.dispatch(new ShipmentTransportOrderCommentsSave({ transportOrder: identifier, comment }));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderCommentsInitialState());
  }
}
